import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import { ReactComponent as IconCrossRound } from "../Images/icon_cross_round.svg";
import { ReactComponent as IconDelete } from "../Images/icon_delete.svg";
import LayoutModal from "../Layout/LayoutModal";
import "../Styles/component.css";
import "../Styles/fonts.css";
import "../Styles/global.css";
import "../Styles/lists.css";
import { postFormData } from "../Utils/apiUtils";
import AlarmSimpleOk from "./AlarmSimpleOk";

const RefundBox = ({ handleClickX, paymentId, reason, orderItemIdArr }) => {
  const navigate = useNavigate();

  const [bank, setBank] = useState("");
  const [name, setName] = useState("");
  const [account, setAccount] = useState("");
  const [uploadedFile, setUploadedFile] = useState(null);
  const [alarmState, setAlarmState] = useState({ show: false, type: "" });
  const [isButtonEnabled, setIsButtonEnabled] = useState(
    bank && name && account && uploadedFile
  );

  const refundGifticon = async () => {
    try {
      const formData = new FormData();
      formData.append("image", uploadedFile);
      formData.append("paymentId", paymentId);
      formData.append("orderItemIdArr", orderItemIdArr);
      formData.append("refundBank", bank);
      formData.append("refundAccount", account);
      formData.append("refundName", name);
      formData.append("refundReason", reason);

      const res = await postFormData(
        "/dashboard/gifticonOrder/refund",
        formData,
        navigate
      );

      if (res.code === 200) {
        setAlarmState({ show: true, type: "success" });
      } else {
        setAlarmState({ show: true, type: "fail" });
      }
    } catch (error) {
      console.error("환불요청 중 에러:", error);
    }
  };

  const handleFileUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      const allowedTypes = ["image/jpeg", "image/png"];
      if (!allowedTypes.includes(file.type)) {
        console.log("이미지 파일이 아님");
        return;
      }
      setUploadedFile(file);
    }
  };
  const removeUploadedFile = () => {
    setUploadedFile(null);
  };

  useEffect(() => {
    setIsButtonEnabled(bank && name && account && uploadedFile);
  }, [bank, name, account, uploadedFile]);

  return (
    <Box>
      {alarmState.show &&
        (alarmState.type === "success" ? (
          <AlarmSimpleOk
            title="환불 요청 완료"
            description={
              <>
                환불 요청이 완료되었습니다.
                <br />
                환불한 금액은 5 영업일(토·일·공휴일 제외)
                <br />
                이내에 환불 계좌로 입금됩니다.
              </>
            }
            handleClickX={() => {
              setAlarmState({ show: false, type: "" });
              handleClickX();
            }}
          />
        ) : (
          <AlarmSimpleOk
            title="환불 요청 실패"
            description="다시 한번 시도해주세요."
            handleClickX={handleClickX}
          />
        ))}
      <div className="hrz-wrapper center">
        <p className="bold-text" style={{ fontSize: "24px" }}>
          환불 정보 입력
        </p>
      </div>
      <div className="hrz-wrapper" style={{ marginTop: "-32px" }}>
        <div style={{ marginLeft: "auto", cursor: "pointer" }}>
          <IconCrossRound onClick={handleClickX} />
        </div>
      </div>

      <p className="medium-text" style={{ marginTop: "30px" }}>
        환불 계좌 정보 입력*
      </p>

      {/* <DropdownOption
        title="은행 선택"
        dropdown_list={bankList}
        width="500px"
        optionChange={setBank}
        page="refund"
      /> */}
      <div
        style={{
          boxShadow: "inset 0 0 0 1px #e4e4e4",
          width: "500px",
          height: "55px",
          marginTop: "14px",
          borderRadius: "10px",
        }}
        className="center"
      >
        <input
          type="text"
          placeholder="은행명 입력 (예시 : ㅇㅇ은행)"
          style={{ outline: "none", border: "none", width: "470px" }}
          onChange={(e) => setBank(e.target.value)}
        />
      </div>
      <div
        style={{
          boxShadow: "inset 0 0 0 1px #e4e4e4",
          width: "500px",
          height: "55px",
          marginTop: "14px",
          borderRadius: "10px",
        }}
        className="center"
      >
        <input
          type="text"
          placeholder="계좌주명 입력"
          style={{ outline: "none", border: "none", width: "470px" }}
          onChange={(e) => setName(e.target.value)}
        />
      </div>
      <div
        style={{
          boxShadow: "inset 0 0 0 1px #e4e4e4",
          width: "500px",
          height: "55px",
          marginTop: "14px",
          borderRadius: "10px",
        }}
        className="center"
      >
        <input
          type="text"
          placeholder="계좌번호 입력(‘-’ 제외)"
          style={{ outline: "none", border: "none", width: "470px" }}
          onChange={(e) => setAccount(e.target.value)}
        />
      </div>

      <p className="medium-text" style={{ marginTop: "14px" }}>
        통장사본 업로드*
      </p>

      <div
        style={{
          marginTop: "14px",
          width: "137px",
          height: "49px",
          borderRadius: "8px",
          boxShadow: "inset 0 0 0 1px #000000",
        }}
        className="center"
      >
        <label
          htmlFor="fileupload"
          style={{
            color: "#000000",
            fontSize: "14px",
            cursor: "pointer",
          }}
        >
          파일 업로드
        </label>
      </div>
      <input
        id="fileupload"
        type="file"
        accept="image/jpeg, image/png"
        onChange={handleFileUpload}
        style={{ display: "none" }}
      />
      <p style={{ marginTop: "8px", fontSize: "14px", color: "#888888" }}>
        · JPG, PNG 이미지 파일로 등록해주세요.
      </p>
      {uploadedFile && (
        <div
          className="center"
          style={{
            display: "flex",
            marginTop: "14px",
            backgroundColor: "#f1f1f1",
            borderRadius: "8px",
            height: "36px",
            width: "500px",
          }}
        >
          <p style={{ color: "#888888", fontSize: "14px", marginLeft: "14px" }}>
            {uploadedFile.name}
          </p>
          <IconDelete
            style={{
              marginLeft: "auto",
              marginRight: "10px",
              cursor: "pointer",
            }}
            onClick={removeUploadedFile}
          />
        </div>
      )}

      <div
        className="blueBtn-base"
        style={{
          marginTop: "30px",
          width: "500px",
          height: "60px",
          borderRadius: "10px",
          backgroundColor: isButtonEnabled ? "#1167ed" : "#b0b0b0",
        }}
        onClick={refundGifticon}
      >
        환불 요청
      </div>
    </Box>
  );
};

const Refund = ({ handleClickX, paymentId, reason, orderItemIdArr }) => {
  return (
    <LayoutModal
      Modal={
        <RefundBox
          handleClickX={handleClickX}
          paymentId={paymentId}
          reason={reason}
          orderItemIdArr={orderItemIdArr}
        />
      }
    />
  );
};

const Box = styled.div`
  padding: 30px;
  background-color: #ffffff;
  border-radius: 20px;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.05);
`;

const DropdownContainer = styled.div`
  width: 500px;
  margin-top: 14px;

  .dropdown {
    width: 100%;
    height: 44px;
    box-shadow: inset 0 0 0 1px #b0b0b0;
    border-radius: 10px;
    font-family: "notoSans-medium";
    font-size: 16px;
    padding: 10px;
    background-color: #fff;
    outline: none;
    border: none;
  }
`;

export default Refund;
